import {
  CardContent,
  Stack,
  TableCell,
  TableRow,
  Typography
} from '@mui/material'
import InCardStack from 'components/atoms/container/InCardStack'
import { NotificationBodyText } from 'components/atoms/Text'
import AvatarHeaderCell from 'components/atoms/table/AvartarHeaderCell'
import PresetTableContainer from 'components/atoms/table/PresetTableContainer'
import UserManagementContainer from 'components/molecules/adminDashboard/UserManagementContainer'
import { useState } from 'react'
import SearchInputBox from 'components/atoms/input/SearchInputBox'
import DeactivateUserButton from './DeactivateUserButton'
import UpgradeUserButton from './UpgradeUserButton'
import InviteMoreButton from './InviteMoreButton'
import UserRoleSelectCell from './UserRoleSelectCell'
import { isMatchingUser } from 'utils/userSearchHelper'
import { useTranslation } from 'react-i18next'
import UserFeaturesSelectCell from './UserFeatureCell'

const RaterOnlyUsersList = ({
  users,
  requestError,
  organization,
  inviteUserCallback,
  isSuperAdminView,
  contentContainerProps,
  licenseActive,
  features,
  fetchLicense,
  deleteUserCallback
}) => {
  const { t } = useTranslation()
  const [raterFilterText, setRaterFilterText] = useState('')
  return (
    <UserManagementContainer
      requestError={requestError}
      titleText={t('company.unlicensedUsers')}
      description={t('company.usersHaveAdministrator')}
      leftPanelComponent={
        <>
          <InviteMoreButton
            organizationId={organization?.id}
            successCallback={inviteUserCallback}
            licenseInvite={false}
            isSuperAdminView={isSuperAdminView}
          />
          <Typography variant='body2'>
            {t('company.adminDoNotRequireUserLicense')}
          </Typography>
        </>
      }>
      {Object.entries(users).filter(([, u]) => !u.userLicense).length > 0 ? (
        <Stack {...contentContainerProps}>
          <SearchInputBox
            onChangeHandler={e => setRaterFilterText(e.target.value)}
            placeholder={t('overview.searchForUser')}
          />
          <PresetTableContainer
            maxHeight='500px'
            shorterRow={true}
            headers={
              <>
                <TableCell>{t('company.userDetails')}</TableCell>
                <TableCell>{t('company.userRole')}</TableCell>
                {isSuperAdminView && (
                  <TableCell>{t('headers.features')}</TableCell>
                )}
                <TableCell width='100px' />
              </>
            }>
            {Object.entries(users)
              .filter(([, u]) => !u.userLicense)
              .filter(([, u]) => isMatchingUser(u, raterFilterText))
              .map(([id, u]) => (
                <TableRow key={id}>
                  <AvatarHeaderCell user={u} />
                  <UserRoleSelectCell user={u} disabled={!licenseActive} />
                  {isSuperAdminView && (
                    <UserFeaturesSelectCell
                      user={u}
                      features={features}
                      licensed={false}
                    />
                  )}
                  <TableCell width='100px'>
                    {licenseActive ? (
                      <InCardStack spacing={0} direction='row'>
                        <UpgradeUserButton
                          successCallback={async () =>
                            await fetchLicense(users)
                          }
                          user={u}
                          organizationId={organization.id}
                          disabled={
                            organization.licenseStats.licensesAvailable <= 0
                          }
                        />
                        <DeactivateUserButton
                          successCallback={deleteUserCallback}
                          user={u}
                        />
                      </InCardStack>
                    ) : null}
                  </TableCell>
                </TableRow>
              ))}
          </PresetTableContainer>
        </Stack>
      ) : (
        <CardContent>
          <NotificationBodyText>
            {t('company.allUsersAccessToMonark')}
          </NotificationBodyText>
        </CardContent>
      )}
    </UserManagementContainer>
  )
}

export default RaterOnlyUsersList
